import React from "react";

export interface ISnackbarContextProps {
  handleOpenSnackbar: (message: string, description: string, error?: boolean) => void;
  openSnackbar: boolean;
  message: string;
  error: boolean;
  description: string;
  handleCloseSnackbar: (
    _?: React.SyntheticEvent | Event,
    reason?: string
  ) => void;
}

export const SnackbarContext = React.createContext({} as ISnackbarContextProps);

interface IProps {
  children: React.ReactNode;
}

export const SnackbarContextProvider: React.FC<IProps> = ({ children }) => {
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [error, setError] = React.useState(false);
  const [description, setDescription] = React.useState("");

  const handleOpenSnackbar = (message: string, description: string, error?: boolean) => {
    setMessage(message);
    setDescription(description);
    setOpenSnackbar(true);

    if (error) {
      setError(error)
    }
  };

  const handleCloseSnackbar = (
    _?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackbar(false);
    setTimeout(() => {

      setError(false)
    }, 8000)
  };

  const value = {
    openSnackbar,
    description,
    message,
    error,
    handleOpenSnackbar,
    handleCloseSnackbar,
  } as ISnackbarContextProps;

  return (
    <SnackbarContext.Provider value={value}>
      {children}
    </SnackbarContext.Provider>
  );
};
